import { useToggle } from '../../hooks';
import { ModalDialog } from '../modal-dialog/ModalDialog';
import { DataPrivacyText } from './styles';
import { Hint } from '../hint/Hint';
import { useTranslations } from 'next-intl';

export const PrivacyHint = () => {
    const t_dialog = useTranslations('dialog');
    const [showModal, toggleModal] = useToggle();

    return (
        <>
            <Hint text={'Hinweis zum Datenschutz'} onClick={() => toggleModal()} />
            <ModalDialog
                hideCancel
                open={showModal}
                title={'Hinweis zum Datenschutz'}
                onClose={toggleModal}
                onSubmit={toggleModal}
                submitText={t_dialog('close')}
            >
                <DataPrivacyText>
                    {
                        'Bitte laden Sie ausschließlich Bilder hoch, an denen Sie die erforderlichen Rechte besitzen. Das bedeutet: Sie dürfen nur eigene Aufnahmen oder Bilder verwenden, für die Sie die ausdrückliche Zustimmung der Urheber*innen eingeholt haben.\n\nSofern auf den Bildern Personen erkennbar sind, stellen Sie bitte sicher, dass alle abgebildeten Personen mit dem Hochladen und der weiteren Verwendung (z. B. Veröffentlichung auf dieser Website) einverstanden sind.\n\nMit dem Upload bestätigen Sie, dass Sie diese Voraussetzungen erfüllen und keine Rechte Dritter verletzen.'
                    }
                </DataPrivacyText>
            </ModalDialog>
        </>
    );
};
